import {styled} from "@mui/material/styles"
import Button from "@mui/material/Button"

// Note: background-color below is to demonstate the effect of templating visually in the browser when Cotton22 template is consumed.
// It should be removed when an official template is developed.
export const Cotton22OpenFiltersButton = styled(Button)`
    && {
        background: ${({theme}) => theme.colours.form.buttonSecondary.background};
        border: ${({theme}) => theme.colours.form.buttonSecondary.border};
        border-radius: ${({theme}) => theme.colours.form.buttonSecondary.radius};
        color: ${({theme}) => theme.colours.form.buttonSecondary.color};
        font-family: ${({theme}) => `${theme.colours.font.primary.regular.family}, ${theme.colours.font.default}`};
        font-size: 0.75rem;
        height: 2.25rem;
        text-transform: uppercase;
        min-width: 7.0625rem;
        max-width: 13.375rem;
        margin-bottom: 0.375rem;

        &:hover,
        &:active,
        &:focus {
            background: ${({theme}) => theme.colours.form.buttonSecondary.background};
            border: ${({theme}) => theme.colours.form.buttonSecondary.border};
            color: ${({theme}) => theme.colours.form.buttonSecondary.color};
        }
        background-color: #808080;
    }
`
